var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-chapter-dropdowns"
  }, [_c('CmSelect', {
    attrs: {
      "nullLabel": "City",
      "includeSearch": "",
      "options": _vm.chapters.map(function (chapter) { return ({
        label: chapter.name,
        value: chapter.abbreviation
      }); })
    },
    model: {
      value: (_vm.chapter),
      callback: function($$v) {
        _vm.chapter = $$v
      },
      expression: "chapter"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73ec4712","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cm-chapter-dropdowns.vue
// module id = null
// module chunks = 